module.exports = __webpack_public_path__ + "static/media/circle.00481853.svg";